<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzWidth]="700"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}"
  (nzOnCancel)="onEmitCloseModal(false)"></nz-modal>

<ng-template #modalTitle>
  <div class="container-steps-modal" [@fadeInAnimation]>
    <p class="text-title-md-bold title-modal"> Crear nuevo servicio</p>
    <p class="text-info mt-xxs">Seleccione la forma de crear el nuevo servicio activo</p>
  </div>
</ng-template>

<ng-template #modalContent>
  <div nz-row [nzGutter]="[50, 50]">
    <div nz-col nzXs="24" nzMd="12">
      <div class="option">
        <div class="img mb-xlg">
          <img loading="lazy" src="./../../../assets/images/new-service.jpg" alt="">
        </div>
        <button
          class="tw-w-full"
          (click)="onEmitSelectOption(false)"
          nz-button nzType="primary">CREAR DESDE CERO
        </button>
        <p class="text-info mt-xlg text-center">Se creará un nuevo servicio, remplazando el servicio actual</p>
      </div>
    </div>
    <div nz-col nzXs="24" nzMd="12">
      <div class="option">
        <div class="img mb-xlg">
          <img loading="lazy" src="./../../../assets/images/duplicate-service.jpg" alt="">
        </div>
        <button
          class="tw-w-full"
          (click)="onEmitSelectOption(true)"
          nz-button nzType="primary">DUPLICAR SERVICIO ACTUAL
        </button>
        <p class="text-info mt-xlg text-center">Se creará un nuevo servicio, duplicando el expediente del servicio actual</p>
      </div>
    </div>
  </div>
  <nz-alert nzType="info"
    *ngIf="!inBilling"
    class="tw-w-full mt-xs"
    nzMessage="¿Cuándo debería crear un nuevo servico?"
    nzDescription="Cuando un paciente ha cumplido o cambiado sus objetivos para las citas."
    nzShowIcon></nz-alert>
</ng-template>

<ng-template #modalFooter>
</ng-template>
